import React, {useEffect} from "react";
import {Link, Navigate} from 'react-router-dom'

import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import EmployeeFullRenderer from './EmployeeFullRendererComponent';

function EmployeeNew(props) {
    console.log('___EmployeeNew___');

    const employee = {
        generalSection: {},
        domiciliuStabil: {},
        domiciliuFlotant: {},
        employmentDetails: {}
    }

    if(props.mostRecentEmployeeId != null) {
        return(
            <Navigate to={`/employees/${props.mostRecentEmployeeId}`} replace />
        );
    }
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>
                
                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to='/employees'>Angajati</Link>
                            <Typography color="text.primary">Adauga Angajat</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <h3>Angajat Nou</h3>
                    </Box>
                    <hr/>

                    <EmployeeFullRenderer 
                        employee={employee} 
                        saveEmployee={props.postEmployee} 
                        employers={props.employers}
                        corCodes={props.corCodes}
                    />
                </Stack>

            </Box>
            </Container>
        );
    }


}

export default EmployeeNew